// extracted by mini-css-extract-plugin
module.exports = {"ButtonPanel":"PanelContainer_ButtonPanel__2jRbq"};